import {BaseLink, useRouter} from "react-router5";
import {useTranslation} from "react-i18next";

export const PostCitation = ({contacts,entites})=>{
    const { t } = useTranslation();
    const router = useRouter();

    const total_length = contacts.length + entites.length

    if (total_length === 0) {
      return  <div className={'postCitationContainer'} />
    }

    return  <div className={'postCitationContainer'}>

        <div className={'postCitationSentence'}>

            {contacts.slice(0,3).map((contact)=> {
              return <BaseLink routeName={'explore.contact'} routeParams={{id:contact.id}} router={router}>
                {contact.firstname + " " + contact.lastname + ", "}
              </BaseLink>
            })}

            {contacts.length < 3 && entites.slice(0,3).map((entite)=>{
              return <BaseLink routeName={'explore.entity'} routeParams={{id:entite.id}} router={router}>
                {entite.name + ", "}
              </BaseLink>
            })}

            {(contacts.length>3 || entites.length>3) ?  `${t('et d\'autres sont cités')}` : `${t("sont cités")}`}
        </div>
        <div className={'postCitationIconContainer'}>
            {contacts.slice(0,5).map((contact)=>{
                return <BaseLink routeName={'explore.contact'} routeParams={{id:contact.id}} router={router}>
                  <img className={'postCitationIcon'} alt={contact.firstname} src={contact.img} />
                </BaseLink>
            })}
            {
                contacts.length < 5 && entites.slice(0, 5).map((entite)=>{
                    return <BaseLink routeName={'explore.entity'} routeParams={{id:entite.id}} router={router}>
                      <img className={'postCitationIcon'} alt={entite.name} src={entite.img} />
                    </BaseLink>
                })
            }
        </div>
    </div>
}
